import { useState, useEffect } from "react";

// Height of the desktop footer, for elements pinned to the bottom of the viewport
// that have to sit clear of it. Read straight from the DOM rather than threaded
// down from Layout: the footer is Layout's, but only bottom-pinned leaves care
// how tall it is. Returns 0 until measured (and on mobile, where the desktop
// footer is display: none) — callers fall back to their own CSS offset.
export default function useFooterHeight() {
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    const footer = document.querySelector("footer.desktop");
    if (!footer) return;

    // borderBoxSize is fractional, unlike offsetHeight.
    const observer = new ResizeObserver(([entry]) => {
      setFooterHeight(entry.borderBoxSize?.[0]?.blockSize ?? entry.target.getBoundingClientRect().height);
    });

    observer.observe(footer);

    return () => observer.disconnect();
  }, []);

  return footerHeight;
}
